// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.distribution-list {
  margin-bottom: 45px;
}
.distribution-list__estimate {
  margin-top: 80px;
  border: 2px solid #000000;
  padding: 20px;
}
@media (max-width: 490px) {
  .distribution-list__estimate {
    margin-top: 50px;
    padding: 7px;
    overflow-x: auto;
  }
}
.distribution-list__projectName {
  font-size: 25px;
  font-weight: 500;
  color: rgb(0, 0, 0);
  cursor: pointer;
}
@media (max-width: 490px) {
  .distribution-list__projectName {
    font-size: 17px;
  }
}
.distribution-list__firstThead {
  width: 180px;
}
@media (max-width: 490px) {
  .distribution-list__firstThead {
    width: 100px;
  }
}
.distribution-list__thead {
  font-size: 18px;
  font-weight: 400;
  font-style: italic;
  color: #808080;
  text-align: center;
  width: 120px;
}
@media (max-width: 490px) {
  .distribution-list__thead {
    width: 50px;
    font-size: 16px;
  }
}
.distribution-list__brigadeName {
  font-size: 20px;
  font-weight: 700;
  color: rgb(0, 0, 0);
  cursor: pointer;
}
@media (max-width: 490px) {
  .distribution-list__brigadeName {
    font-size: 16px;
  }
}
.distribution-list__total {
  font-size: 17px;
  font-weight: 700;
  color: rgb(0, 0, 0);
  text-align: center;
}
@media (max-width: 490px) {
  .distribution-list__total {
    font-size: 15px;
  }
}
.distribution-list__datePayment {
  font-size: 17px;
  font-weight: 400;
  color: rgb(0, 0, 0);
  font-style: italic;
  margin-left: 30px;
}
@media (max-width: 490px) {
  .distribution-list__datePayment {
    font-size: 15px;
    margin-left: 15px;
  }
}
.distribution-list__totalPayment {
  font-size: 16px;
  font-weight: 400;
  color: rgb(0, 0, 0);
  text-align: center;
}
@media (max-width: 490px) {
  .distribution-list__totalPayment {
    font-size: 14px;
  }
}
.distribution-list__totalBottom {
  font-size: 21px;
  font-weight: 400;
  color: rgb(0, 0, 0);
  text-align: center;
}
@media (max-width: 490px) {
  .distribution-list__totalBottom {
    font-size: 19px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Distribution/style.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;AACJ;AAAI;EACI,gBAAA;EACA,yBAAA;EACA,aAAA;AAER;AADQ;EAJJ;IAKQ,gBAAA;IACA,YAAA;IACA,gBAAA;EAIV;AACF;AAEI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAAR;AACQ;EALJ;IAMQ,eAAA;EAEV;AACF;AAEI;EACI,YAAA;AAAR;AACQ;EAFJ;IAGQ,YAAA;EAEV;AACF;AACI;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;AACR;AAAQ;EAPJ;IAQQ,WAAA;IACA,eAAA;EAGV;AACF;AACI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AACR;AAAQ;EALJ;IAMQ,eAAA;EAGV;AACF;AAAI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAER;AADQ;EALJ;IAMQ,eAAA;EAIV;AACF;AADI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAGR;AAFQ;EANJ;IAOQ,eAAA;IACA,iBAAA;EAKV;AACF;AAFI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAIR;AAHQ;EALJ;IAMQ,eAAA;EAMV;AACF;AAHI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAKR;AAJQ;EALJ;IAMQ,eAAA;EAOV;AACF","sourcesContent":[".distribution-list {\n    margin-bottom: 45px;\n    &__estimate {\n        margin-top: 80px;\n        border: 2px solid #000000;\n        padding: 20px;\n        @media(max-width: 490px) {\n            margin-top: 50px;\n            padding: 7px;\n            overflow-x: auto;\n        }\n       \n     \n        \n    }\n\n    &__projectName {\n        font-size: 25px;\n        font-weight: 500;\n        color: rgb(0,0,0);\n        cursor: pointer;\n        @media(max-width: 490px) {\n            font-size: 17px;\n        }\n    }\n\n\n    &__firstThead {\n        width: 180px;\n        @media(max-width: 490px) {\n            width: 100px;\n        }\n    }\n\n    &__thead {\n        font-size: 18px;\n        font-weight: 400;\n        font-style: italic;\n        color: #808080;\n        text-align: center;\n        width: 120px;\n        @media(max-width: 490px) {\n            width: 50px;\n            font-size: 16px;\n        }\n       \n    }\n\n    &__brigadeName {\n        font-size: 20px;\n        font-weight: 700;\n        color: rgb(0,0,0);\n        cursor: pointer;\n        @media(max-width: 490px) {\n            font-size: 16px;\n        }\n    }\n\n    &__total {\n        font-size: 17px;\n        font-weight: 700;\n        color: rgb(0,0,0);\n        text-align: center;\n        @media(max-width: 490px) {\n            font-size: 15px;\n        }\n    }\n\n    &__datePayment {\n        font-size: 17px;\n        font-weight: 400;\n        color: rgb(0,0,0);\n        font-style: italic;\n        margin-left: 30px;\n        @media(max-width: 490px) {\n            font-size: 15px;\n            margin-left: 15px;\n        }\n    }\n\n    &__totalPayment {\n        font-size: 16px;\n        font-weight: 400;\n        color: rgb(0,0,0);\n        text-align: center;\n        @media(max-width: 490px) {\n            font-size: 14px;\n        }\n    }\n\n    &__totalBottom {\n        font-size: 21px;\n        font-weight: 400;\n        color: rgb(0,0,0);\n        text-align: center;\n        @media(max-width: 490px) {\n            font-size: 19px;\n        }\n    }\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
